import tooltip from 'components/chartView/tooltip';
import { map as colors } from './colors';

export default {
  plotOptions: {
    series: {
      showInNavigator: true,
      marker: {
        fillColor: '#FFFFFF',
        lineColor: null,
        lineWidth: 2,
        symbol: 'circle',
        radius: 4,
      },
    },
    line: {
      connectNulls: true,
    },
  },
  legend: {
    enabled: true,
    verticalAlign: 'middle',
    align: 'right',
    layout: 'vertical',
    itemMarginBottom: 15,
  },
  responsive: {
    rules: [{
      condition: {
        maxWidth: 767,
      },
      chartOptions: {
        legend: {
          enabled: true,
          verticalAlign: 'bottom',
          align: 'center',
          layout: 'horizontal',
          itemMarginBottom: 0,
        },
      },
    }],
  },
  credits: {
    enabled: false,
  },
  title: {
    text: null,
  },
  yAxis: {
    title: {
      text: null,
    },
  },
  tooltip: {
    shared: true,
    formatter() {
      const year = this.points[0].key;
      const series = this.points.map(({ point: { item } }) =>
        `${item.geography}: ${item.formattedValue}`);
      return tooltip({ year, series });
    },
    backgroundColor: 'rgba(67, 82, 102, 0.9)',
    borderRadius: 0,
    borderWidth: 0,
    style: {
      color: '#FFFFFF',
      fontSize: '13px',
    },
    shadow: false,
    useHTML: true,
  },
  xAxis: {
    type: 'category',
  },
  colors,
};



// WEBPACK FOOTER //
// ./app/config/chartConfig.js